import FormHelpers from "../../../../helpers/FormHelpers";

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in (${fieldName}) field. Select/Enter a valid value then proceed.`,
};

const validateDocLevel = ({
  cfPurchaseRequestDoc, issuerTenantDepartment, selectedIssuerTenant, mrNumber,
}) => {
  const errors = [];

  if(!mrNumber) {
    errors.push({
      name: 'MR Number',
      value: 0,
      message: ERROR_MESSAGES.requiredField('MR Number'),
    });
  }

  if (cfPurchaseRequestDoc) {
    cfPurchaseRequestDoc.forEach((field) => {
      if (field.isRequired && field?.isActive) {
        errors.push({
          name: field?.fieldName,
          value: field?.fieldValue,
          message: ERROR_MESSAGES.requiredField(field?.fieldName),
        });
      }
    });
  }
  // Check if `issuerTenantDepartment` and `selectedIssuerTenant` both are present
  if ((issuerTenantDepartment && !selectedIssuerTenant) || (!issuerTenantDepartment && selectedIssuerTenant)) {
    errors.push({
      name: 'Issuer Tenant Fields',
      message: 'Issuer Tenant and Department must both be selected or both left empty.',
    });
  }

  return errors;
};

const validateLineLevel = ({ data, cfPurchaseRequestLine, targetPriceMandatory }) => {
  const errors = [];
  if (data) {
    data.forEach((item) => {
      if (!item?.product_sku_name) {
        errors.push({
          name: "Products",
          value: 0,
          message: "Error in Product. Select a product to continue.",
        });
      } else {
        if(targetPriceMandatory && !item?.targetPrice){
          errors.push({
            name: `Target Price in Product ${item?.internal_sku_code || ""}`,
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Target Price in Product '${item?.internal_sku_code || ""}'`)
          })
        }
        if(!item?.quantity){
          errors.push({
            name: `Quantity in Product ${item?.internal_sku_code || ""}`,
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Quantity in Product '${item?.internal_sku_code || ""}'`)
          })
        }
        if (cfPurchaseRequestLine) {
          item?.lineCustomFields.filter((field) => field?.fieldName !== "Quantity" && field?.fieldName !== "Rate")?.forEach((field) => {
            if (field.isRequired && field?.isActive) {
              errors.push({
                name: field?.fieldName,
                value: field?.fieldValue,
                message: ERROR_MESSAGES.requiredField(`${field?.fieldName} for Product '${item?.internal_sku_code || ""}`),
              });
            }
          });
        }
      }
    });
  }

  return errors;
};

const purchaseRequestErrorList = (params) => {
  const docLevelErrors = validateDocLevel(params);
  const lineLevelErrors = validateLineLevel(params);

  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors});
};

export default purchaseRequestErrorList;